/* eslint-disable react/react-in-jsx-scope */
import LoginForm from "@/auth/components/LoginForm";
import { useAuth } from "@/auth/hooks/useAuth";
import { LoadingSpinner } from "@/components/ui/loadingSpinner";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import slugify from "slugify";

const Auth = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, loading } = useAuth();

  if (isAuthenticated && user?.isVerified) {
    if (user?.status === 1) {
      navigate(`/${slugify(user.fullname, { lower: true, trim: true })}`, {
        replace: true,
      });
    } /*else if (redirect) { 
      window.location.href = redirect;
    } */ else {
      navigate(`/submit/programs`);
    }
    return <></>;
  }

  if (loading)
    return (
      <div className="container min-h-screen">
        <LoadingSpinner />
      </div>
    );
  //Todo: Rédirection de l'utilisateur vers la page code s'il n'est pas vérifié et on lui envoie un code mail
  return (
    <div className="container ">
      <div className="mx-auto mb-5 mt-8 flex justify-center lg:w-3/4">
        <div className="w-full md:w-1/2 px-4">
          <LoginForm />
        </div>
      </div>
    </div>
  );
};

export default Auth;
